
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTempCold as ObiTempColdElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-temp-cold.js';
 
 
 

 
 export const ObiTempCold = createComponent({
   react: React,
   tagName: 'obi-temp-cold',
   elementClass: ObiTempColdElement,
   events: {
     
   }
  });
 
 